module.exports = __webpack_public_path__ + "img/icn_ea.e760ca22.svg";